import { Component, Input, Output, OnChanges, SimpleChanges, SimpleChange, EventEmitter } from '@angular/core';
import { Observable, Subject } from 'rxjs/Rx';
import { NetFacadeService } from '../../../services/netfacade.service';
import { AgentDto } from 'UvExplorerServer.Dtos.TS/Agents';
import { NetViewDto } from 'UvExplorerServer.Dtos.TS/NetViews';
import { MessageService } from 'base';


@Component({
    selector: 'new-agent-dialog',
	templateUrl: './newagent.component.html',
    styleUrls: ['./newagent.component.scss']
})
export class NewAgentDialogComponent implements OnChanges {

    @Input() display: boolean = false;
    @Input() parent: NetViewDto;
	@Output() onSuccess = new EventEmitter();
	@Output() onClose = new EventEmitter();

    newItemName: string = "";
	newItemDesc: string = "";

	constructor(private netFacadeService: NetFacadeService,
				private messageService: MessageService) {
	}

	public ngOnChanges(changes: SimpleChanges): void {
		let change: SimpleChange = null;

		change = changes["display"];
		if (change) {
			if (this.display) {
				this.newItemName = "";
				this.newItemDesc = "";
			}
		}
	}

	public onDialogHide(): void {
		this.onClose.emit(true);
	}

    public addNewAgent(): void {
		this.netFacadeService.createAgent(this.newItemName, this.newItemDesc, this.parent).subscribe(
			(newAgent: AgentDto) => {
				this.onSuccess.emit(true);
			},
			(error: any) => {
				this.messageService.displayErrorMessage("Agent creation failed");
			});
    }

    public displayDialog() {
        this.display = true; 
    }

    public hideDialog() {
        this.display = false;
	}
}
